<app-side-menu>
  <div class="detail-container">
    <div class="row mb-3">
      <div class="col-12">
        <div class="page-header d-flex justify-content-between align-items-center flex-wrap gap-2">
          <div>
            <button type="button" class="btn btn-link p-0 mb-2 text-muted" (click)="goBack()">
              <i class="fas fa-arrow-left me-1"></i> Voltar às pendências
            </button>
            <h1 class="page-title">
              <i class="fas fa-file-invoice me-3"></i>
              Detalhe — IPVA / Licenciamento
            </h1>
          </div>
          <div *ngIf="item?.externalReference">
            <button type="button" class="btn btn-outline-primary btn-sm" (click)="refreshStatus()" [disabled]="refreshing">
              <i class="fas fa-sync" [class.fa-spin]="refreshing"></i>
              Atualizar status no banco
            </button>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="error" class="alert alert-danger">{{ error }}</div>

    <div *ngIf="loading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Carregando...</span>
      </div>
    </div>

    <div class="card" *ngIf="!loading && item">
      <div class="card-body">
        <dl class="row mb-0">
          <dt class="col-sm-3">Tipo</dt>
          <dd class="col-sm-9">{{ item.paymentType }}</dd>

          <dt class="col-sm-3">Ano de referência</dt>
          <dd class="col-sm-9">{{ item.referenceYear }}</dd>

          <dt class="col-sm-3">Valor</dt>
          <dd class="col-sm-9">{{ formatCurrency(item.amount) }}</dd>

          <dt class="col-sm-3">Data do pagamento</dt>
          <dd class="col-sm-9">{{ formatDate(item.paymentDate) }}</dd>

          <dt class="col-sm-3">Status</dt>
          <dd class="col-sm-9">
            <span class="badge bg-secondary">{{ item.status }}</span>
          </dd>

          <dt class="col-sm-3">Número do documento</dt>
          <dd class="col-sm-9">{{ item.documentNumber || '—' }}</dd>

          <dt class="col-sm-3">Referência externa (banco)</dt>
          <dd class="col-sm-9">{{ item.externalReference || '—' }}</dd>

          <dt class="col-sm-3">Observações</dt>
          <dd class="col-sm-9">{{ item.notes || '—' }}</dd>
        </dl>
      </div>
    </div>
  </div>
</app-side-menu>
